import React, { useEffect, useState } from "react";
import { List, Datagrid, TextField, DateField, FunctionField, SelectInput, TopToolbar, ExportButton } from "react-admin";
import { getNameAndCompanyName, getResource, monthChoices } from "../common";
import { Link } from "react-router-dom";
import { downloadCSV } from 'react-admin';
import { unparse } from 'papaparse';
import CustomCreateButton from "../components/CustomeCreateButton";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const EstimateHistoryList = () => {
  const [customers, setCustomers] = useState([]);
  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_DIR}/customers/all`, {
          method: "GET",
          headers: new Headers({ "Content-Type": "application/json" }),
          mode: "cors",
          credentials: "include",
        });
        if (!response.ok) {
          throw new Error("Failed to fetch user info");
        }
        const { data } = await response.json();
        setCustomers(data);
      } catch (error) {
        console.error("ユーザー情報の取得に失敗しました:", error);
      } finally {
        // setLoading(false);
      }
    };

    fetchUser();
  }, []);

  // const customExporter = (records) => {
  //   // エクスポートするデータをカスタムフォーマットに変換
  //   const csvData = records.map(record => {

  //     return {
  //       // "見積No": String(record.number).padStart(5, "0"), 
  //       "見積作成日": record.createEstimateDate ? new Date(record.createEstimateDate).toLocaleDateString() : "",
  //       "見積依頼日": record.requestEstimateDate ? new Date(record.requestEstimateDate).toLocaleDateString() : "",
  //       "見積金額(税抜き)": record.estimateAmount ? `${record.estimateAmount.toLocaleString()}` : "",
  //       "見積作成者": record.createrName ?? "",
  //       "顧客名": getCustomer(record.customerId) ? `${getNameAndCompanyName(getCustomer(record.customerId).surname,getCustomer(record.customerId).name,getCustomer(record.customerId).companyName)}`: "",
  //     }

  //   });
  //   const csv = "\uFEFF" + unparse(csvData, { header: true });
  //   downloadCSV(csv, `見積履歴_` + new Date().toLocaleDateString());
  // };

  const customExporter = (records) => {
    // エクスポートするデータをカスタムフォーマットに変換
    const excelData = records.map(record => ({
      // "見積No": String(record.number).padStart(5, "0"), 
      "見積作成日": record.createEstimateDate ? new Date(record.createEstimateDate).toLocaleDateString() : "",
      "見積依頼日": record.requestEstimateDate ? new Date(record.requestEstimateDate).toLocaleDateString() : "",
      "見積金額(税抜き)": record.estimateAmount ? `${record.estimateAmount.toLocaleString()}` : "",
      "見積作成者": record.createrName ?? "",
      "顧客名": getCustomer(record.customerId)
        ? `${getCustomer(record.customerId).bukken ?? ""}`
        : "",
    }));

    // ワークシート作成
    const worksheet = XLSX.utils.json_to_sheet(excelData);

    // 列幅を設定（wch: 文字数ベース）
    worksheet['!cols'] = [
      { wch: 15 }, // 見積作成日
      { wch: 15 }, // 見積依頼日
      { wch: 18 }, // 見積金額(税抜き)
      { wch: 20 }, // 見積作成者
      { wch: 30 }, // 顧客名
    ];

    // ワークブックに追加
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "見積履歴");

    // バッファ出力
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    // ダウンロード
    const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    saveAs(blob, `見積履歴_${new Date().toLocaleDateString()}.xlsx`);
  };


  const getCustomer = (customerId) => {
    const customer = customers.find(req => req.id === customerId);
    return customer;
  }


  const CustomerFilters = [
    <SelectInput
      source="month"
      label={<span style={{ fontSize: "12px" }}>見積依頼月</span>}
      choices={monthChoices}
      alwaysOn
      sx={{
        ".MuiInputBase-root": { height: "35px" },
        ".MuiInputBase-input": {
          fontSize: "12px"
        },
      }}
    />
  ];

  const handleRowClick = (id, basePath, record) => {
    const url = `${window.location.origin}/#/${basePath}/show/${id}`;
    const features = 'width=1200,height=800,left=200,top=100,noopener,noreferrer';
    window.open(url, '_blank', features);
    return false;
  };

  const CustomersActions = () => (
    <TopToolbar>
      <CustomCreateButton basePath="/estimateHistory" />
      <ExportButton exporter={customExporter} />
    </TopToolbar>
  );

  return (
    <List filters={CustomerFilters} actions={<CustomersActions />} sort={{ field: "createEstimateDate", order: "ASC" }}>
      <Datagrid rowClick={(id, basePath, record) => handleRowClick(id, basePath, record)} bulkActionButtons={false}>
        {/* <FunctionField source="number" label="見積No" render={(record) => {
          return String(record.number).padStart(5, "0");
        }}/> */}
        <DateField source="createEstimateDate" label="見積作成日" />
        <DateField source="requestEstimateDate" label="見積依頼日" />
        <FunctionField source="estimateAmount" label="見積金額(税抜き)"
          render={(record) => {
            return record.estimateAmount ? `${record.estimateAmount.toLocaleString()}円` : ""
          }}
        />
        <TextField source="createrName" label="見積作成者" />
        <FunctionField
          source="customerId"
          label="顧客名"
          render={(record) => {
            const customer = getCustomer(record.customerId);
            return customer ? <Link to={`/${getResource(customer)}/show/${record.customerId}`}>{`${customer.bukken ?? ""}`}</Link> : "";
          }}
          onClick={(e) => e.stopPropagation()}
        />
      </Datagrid>
    </List>
  );
}

export default EstimateHistoryList;
